import { SegmentFieldItem } from './segment-field-item.interface';
import { Option } from 'shared/form/select/option.interface';

/* eslint-disable */
export const customFieldsSegmentData: Array<SegmentFieldItem> = [
  {
    "field_map": "type_id",
    "item_name": "type_id",
    "title": " Custom Field Type",
    "hint_detail": "PIES Segment type.",
    "hint_panel" : "PIES Segment type.",
    "example": "Attributes",
    "sequence": 1,
    "show_more": true,
    "lookup": [
      {
        'option': 1,
        'title': 'Attributes'
      },
      {
        'option': 2,
        'title': 'Pricing'
      },
      {
        'option': 3,
        'title': 'Description 80'
      },
      {
        'option': 4,
        'title': 'Description 200'
      },
      {
        'option': 5,
        'title': 'Description 240'
      },
      {
        'option': 6,
        'title': 'Description 2000'
      },
    ],
  },
  {
    "field_map": "label",
    "item_name": "label",
    "title": " Custom Field Label",
    "hint_detail": "User-defined custom field.",
    "hint_panel" : "User-defined custom field.",
    "example": "Material",
    "sequence": 2,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "value",
    "item_name": "value",
    "title": " Custom Field Value",
    "type": "list",
    "hint_detail": "Value of the custom field.",
    "hint_panel" : "Value of the custom field.",
    "example": "Aluminum",
    "sequence": 3,
    "show_more": true,
    "lookup": null,
  },
];

export const descriptionLabelLookup80: Array<Option> = [
  {
    'option': 'DES',
    'title': 'Long description'
  },
  {
    'option': 'LAB',
    'title': 'Label description'
  },
  {
    'option': 'KEY',
    'title': 'Key search words'
  },
  {
    'option': 'SLA',
    'title': 'Slang description'
  },
];

export const descriptionLabelLookup200: Array<Option> = [
  {
    'option': 'TLE',
    'title': 'Product Description - SEO'
  }
];

export const descriptionLabelLookup240: Array<Option> = [
  {
    'option': 'EXT',
    'title': 'Extended description'
  },
  {
    'option': 'FAB',
    'title': 'Features and Benefits'
  },
  {
    'option': 'ASM',
    'title': 'Application summary'
  },
  // "TTP": "Technical Tips",
  {
    'option': 'TTP',
    'title': 'Technical Tips'
  }
];

export const descriptionLabelLookup2000: Array<Option> = [
  {
    'option': 'ASC',
    'title': 'Associated comments'
  },
  {
    'option': 'MKT',
    'title': 'Marketing description'
  },
  // "TTD": "Technical Tips Marketing Description",
  {
    'option': 'TTD',
    'title': 'Technical Tips Marketing Description'
  }
];

export const customFieldsTypeFilters: Array<Option> = [
  {
    'option': 0,
    'title': 'All',
  },
  {
    'option': 1,
    'title': 'Attributes',
  },
  {
    'option': 2,
    'title': 'Pricing',
  },
  {
    'option': 10,
    'title': 'Descriptions',
  },
];

/* eslint-enable */
